const { decode: decodeV0, parse: parseV0 } = require('../v0/response')

module.exports = {
  decode: decodeV0,
  parse: parseV0,
}
